import React, { memo } from 'react'
import { Alert, Stack } from '@mui/material'

import FaIcon from 'src/components/shared/faIcon/FaIcon'
import Button from '../shared/button/Button'
import ExternalLink from '../shared/text/ExternalLink'
import brandConfig from 'brandConfig'

const KYCAlert = ({ t, severity, title, icon, support, sx }) => {
  return (
    <Alert
      severity={severity}
      icon={icon ? <FaIcon icon={icon} /> : false}
      sx={{ py: 0, px: 1, ...sx }}
    >
      <Stack direction='row' alignItems='center' justifyContent='space-between'>
        <>{t(title)}</>
        {support && (
          <ExternalLink
            to={`mailto:${brandConfig.supportEmail}?subject=KYC%20verification%20failed%20-%20QBX%20VIP%20Club&body=Hi%20qiibee%20team%2C%0A%0AHelp%2C%20my%20KYC%20verification%20failed%20in%20the%20QBX%20VIP%20Club.%0A%0A-%20Add%20basic%20account%20info%20here%20-%0AMy%20full%20name%20is%20(as%20seen%20on%20the%20ID%2FPassport)%3A%20%0AMy%20VIP%20Club%20account%20number%20is%3A%20%0A%0AKind%20regards`}
            label={
              <Button
                label={t('kyc.contact-support')}
                size='small'
                sx={{ ml: 2 }}
              />
            }
          />
        )}
      </Stack>
    </Alert>
  )
}

export default memo(KYCAlert)
